import React from "react";

import "./ApprovalUpdateItem.scss";

import Divider from "components/v2/Divider/Divider";
import { ReactComponent as ArrowDownIcon } from "assets/images/iconsV2/arrow-down.svg";
import { ReactComponent as InfoCircleIcon } from "assets/images/iconsV2/info-circle.svg";
import Badge from "components/v2/Badge/Badge";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ApprovalUpdateItemStatus, { ApprovalUpdateItemStatusType } from "./ApprovalUpdateItemStatus";

type ApprovalUpdateItemProps = {
  title: React.ReactNode;
  subTitle?: string;
  status?: ApprovalUpdateItemStatusType;
  date?: string;
  comment?: string;
  showArrow?: boolean;
  viaEmail?: boolean;
  action?: React.ReactNode;
  additionalData?: Record<string, any>;
};

function ApprovalUpdateItem(props: ApprovalUpdateItemProps) {
  const { title, subTitle, status, date, comment, showArrow, viaEmail, action, additionalData } = props;

  return (
    <div className="approval-update-item">
      <div className="text-sm font-medium text-secondary-v2">{title}</div>
      {subTitle && <div className="text-xs text-tertiary">{subTitle}</div>}
      <div className="mt-xs d-flex justify-content-between align-items-center">
        {(status || viaEmail) && (
          <div className="d-flex align-items-center">
            {status && <ApprovalUpdateItemStatus status={status} additionalData={additionalData} />}
            {viaEmail && (
              <div className="ml-xs">
                <Badge
                  color="gray"
                  label="via email"
                  type="status-badge"
                  variant="icon-trailing"
                  icon={
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 0 }}
                      overlay={
                        <Tooltip id="button-tooltip">
                          Approvals done via email will automatically request approval from all users in the next approval
                          level.
                        </Tooltip>
                      }
                    >
                      <InfoCircleIcon width={12} height={12} />
                    </OverlayTrigger>
                  }
                />
              </div>
            )}
          </div>
        )}
        {date && <div className="text-xs text-quaternary text-right">{date}</div>}
      </div>
      {action && <div className="mt-md">{action}</div>}
      {comment && (
        <>
          <Divider className="my-md" />
          <div className="text-xs text-secondary-v2">Comment:</div>
          <div className="text-xs text-primary text-break">{comment}</div>
        </>
      )}
      {showArrow && (
        <div className="approval-update-item__arrow">
          <ArrowDownIcon />
        </div>
      )}
    </div>
  );
}

export default ApprovalUpdateItem;

ApprovalUpdateItem.defaultProps = {
  subTitle: null,
  status: null,
  date: null,
  comment: null,
  showArrow: true,
  viaEmail: false,
  action: null,
  additionalData: undefined,
};
